__turbopack_context__.v({
  "date": "RelatedEventCard-module-scss-module__d_HDYq__date",
  "dateWrapper": "RelatedEventCard-module-scss-module__d_HDYq__dateWrapper",
  "grid": "RelatedEventCard-module-scss-module__d_HDYq__grid",
  "imageWrapper": "RelatedEventCard-module-scss-module__d_HDYq__imageWrapper",
  "linegap": "RelatedEventCard-module-scss-module__d_HDYq__linegap",
  "link": "RelatedEventCard-module-scss-module__d_HDYq__link",
  "location": "RelatedEventCard-module-scss-module__d_HDYq__location",
  "locationWrapper": "RelatedEventCard-module-scss-module__d_HDYq__locationWrapper",
  "price": "RelatedEventCard-module-scss-module__d_HDYq__price",
  "priceWrapper": "RelatedEventCard-module-scss-module__d_HDYq__priceWrapper",
  "promoted": "RelatedEventCard-module-scss-module__d_HDYq__promoted",
  "promotedWrapper": "RelatedEventCard-module-scss-module__d_HDYq__promotedWrapper",
  "signalBadgeWrapper": "RelatedEventCard-module-scss-module__d_HDYq__signalBadgeWrapper",
  "title": "RelatedEventCard-module-scss-module__d_HDYq__title",
  "titleWrapper": "RelatedEventCard-module-scss-module__d_HDYq__titleWrapper",
  "wrapper": "RelatedEventCard-module-scss-module__d_HDYq__wrapper",
});
